import type { Complexity } from '@/core/theory/chord';
/** Chord detail levels (F2.11). */
export const COMPLEXITY_OPTIONS: { value: Complexity; label: string; ariaLabel: string }[] = [
  { value: 'simple', label: 'Simple', ariaLabel: 'Simple: major and minor only' },
  { value: 'standard', label: 'Standard', ariaLabel: 'Standard: sevenths, sus and dim too' },
  { value: 'advanced', label: 'Advanced', ariaLabel: 'Advanced: every chord detected' },
];
